import { RtnCode } from '@library/enums/rtn-code'
import type { ResponseData, ResponseSuccessData } from '@library/services'

export function isApiSuccess<T = any>(
  responseData: ResponseData<T>
): responseData is ResponseSuccessData<T> {
  return responseData.rtnCode === RtnCode.CODE_SUCCESS
}
